export enum VehicleType {
  CAR = 1,
}

export enum DriverPersonality {
  NEUTRAL = 1,
  GRANNY = 2,
  CRAZY = 3,
}
